import { logger } from '../../../../utils/logger';
import {
  buildConnectionSnapshot,
  getVoiceInternalsFromWindow,
  logJssipInternals,
  logJssipRegistrationFailure,
} from './jssip-access.util';

export function startConnectionWatcher(): void {
  let checkCount = 0;
  let lastState = '';

  const watchInterval = setInterval(() => {
    checkCount++;
    const { voiceClient, webRtcService, audioCode, jssipUA } = getVoiceInternalsFromWindow();
    const currentState = JSON.stringify(
      buildConnectionSnapshot(voiceClient, webRtcService, audioCode, jssipUA)
    );

    if (currentState !== lastState) {
      logger.debug(
        `[CXone WATCHER] State change at ${checkCount * 200}ms:`,
        JSON.parse(currentState)
      );
      lastState = currentState;

      if (jssipUA) {
        logJssipInternals(jssipUA);
      }
    }

    if (jssipUA?.isRegistered?.()) {
      logger.debug('[CXone WATCHER] SIP registration completed successfully!');
      clearInterval(watchInterval);
      return;
    }

    if (checkCount >= 150) {
      logger.warn(
        '[CXone WATCHER] Stopping after 30 seconds. Final state:',
        JSON.parse(currentState)
      );
      if (jssipUA && !jssipUA.isRegistered?.()) {
        logger.error('[CXone WATCHER] SIP registration never completed!');
        logJssipRegistrationFailure(jssipUA);
      }
      clearInterval(watchInterval);
    }
  }, 200);
}
